module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-bounceprevent-f85bebe3da06edb71f1f15e649f0d487.gif";